import { getChannelAPIPath } from '@treasury/core/http';

CountriesService.$inject = ['$resource', '$q'];

export default function CountriesService($resource, $q) {
    return {
        getAll,
    };

    function getAll() {
        return $resource(`${getChannelAPIPath()}countries/`).query().$promise;
    }
}
